import { createApi } from "@reduxjs/toolkit/query/react";
import customFetchBase from "./customFetchBase";
import { IUser } from "../../Models/User";
import {
  IGenericResponse,
  IPaginatedList,
  IPaginationQuery,
} from "Interfaces/PaginatedList";
import { getQueryParams } from "utils/getQueryParams";
import { UserFilters } from "Interfaces/UserFilters";

export const userApi = createApi({
  reducerPath: "userApi",
  baseQuery: customFetchBase,
  tagTypes: ["Users"],
  endpoints: (builder) => ({
    getUsers: builder.query<IPaginatedList<IUser>, IPaginationQuery<UserFilters>>({
      query(queryFilters) {
        return {
          url: getQueryParams(`users`, queryFilters),
          credentials: "include",
        };
      },
      transformResponse: (results: IGenericResponse<IPaginatedList<IUser>>) =>
        results.data,
      providesTags: () => ["Users"],
    }),
    // Get single user

    getUser: builder.query<IUser, string>({
      query(userId) {
        return {
          url: "users/" + userId,
          method: "GET",
          credentials: "include",
        };
      },
      providesTags: ["Users"],
      transformResponse: (result: { data: IUser }) => {
        return result.data;
      },
    }),

    // Delete user

    deleteUser: builder.mutation<IUser, string>({
      query(userId) {
        return {
          url: "users/" + userId,
          method: "DELETE",
          credentials: "include",
        };
      },
      invalidatesTags: ["Users"],
      transformResponse: (result: { data: IUser }) => {
        return result.data;
      },
    }),
    //get company admin
    getCompanyAdmin: builder.query<IUser, void>({
      query() {
        return {
          url: "users/company/admin",
          method: "GET",
          credentials: "include",
        };
      },
      providesTags: ["Users"],
      transformResponse: (result: { data: IUser }) => {
        return result.data;
      },
    }),
  }),
});

export const { useGetUsersQuery, useGetUserQuery, useDeleteUserMutation, useGetCompanyAdminQuery } =
  userApi;
